<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount } from 'vue'
import ModalDialog from "../../compositions/ModalDialog.vue";
import CustomList from "../../compositions/CustomList.vue";
import CustomEvent from "../../compositions/CustomEvent.vue";
import config from "../../config.js";
import qs from 'qs';
import { useHelpStore } from '../../stores/help';
import axios from '../../plugins/axios.ts';

const help = useHelpStore();
const isOpen = ref(false);
if (help.helpExists()) {
  isOpen.value = true;
}
const props = defineProps({
    apis:{
      type:Object,
      required:true,
    }
})
const listRef = ref();
const helpButtonRef = ref();
const isListShow = ref(false);
const isLoading = ref(false);
const isShowDialog = ref(false);

const showHelpContent = (item) => {
  isOpen.value = true;
  help.showHelp(document.body,item.help_key);
  helpClose();
}
const closeDialog = () => {
  isClosing.value = true;
  isShowDialog.value = false;
}
const showDialog = (index:int) => {
  isShowDialog.value = true;
}

const helpClick = () => {
  if (!isListShow.value) {
    if (help.helpExists()) {
      isOpen.value = false;
      help.closeHelp();
      return;
    }
  }
  isListShow.value = !isListShow.value;
}
const helpClose = () => {
  if (isShowDialog.value == true) {
    return;
  }
  isListShow.value = false;
}
const helpReset = () => {
  isClosing.value = true;
}
const helpResize = () => {
  help.helpResize();
}
const {element,isClosing,clickOutside} = CustomEvent(helpClose)

onBeforeUnmount(() => {
  window.removeEventListener('click', clickOutside);
  window.removeEventListener('resize', helpResize);
  window.removeEventListener('DOMContentLoaded', helpResize);
  window.removeEventListener('scroll', helpResize);
});
const recoverHelp = () => {
  help.recoverHelp();
}
onMounted(() => {
  window.addEventListener('DOMContentLoaded', (event) => {
      recoverHelp();
  });
  window.addEventListener('click', clickOutside);
  window.addEventListener('resize', helpResize);
  window.addEventListener('scroll', helpResize);
});

</script>

<style scoped>
</style>
<template>
<div ref="element">
  <!-- Help -->
  <div class="md:ml-3">
    <button ref="helpButtonRef" type="button" data-dropdown-toggle="notification-dropdown" class="help-button-item text-xl inline-flex relative items-center p-1 md:p-2 text-gray-600 rounded-lg hover:text-gray-900 hover:bg-gray-100" @click="helpClick">
      <span class="sr-only">ヘルプを見る</span>
      <!-- Bell icon -->
      <i v-if="!isOpen" class="fa-solid fa-circle-question"></i><i v-else class="w-6 h-6 fa-regular fa-rectangle-xmark"></i>
    </button>
    <!-- Dropdown menu -->
    <div v-show="isListShow" class="absolute mb-4 max-w-sm text-base list-none bg-white rounded divide-y divide-gray-100 shadow-lg">
      <custom-list
        ref="listRef"
        :api-url="apis.help_list"
        :is-searchable="true"
        :reset="helpReset"
      >
      <template v-slot:item="slotProps">
        <div class="w-full" @click="showHelpContent(slotProps.item)">{{ slotProps.item.title }}</div>
      </template>
      </custom-list>
    </div>
  </div>
</div>
</template>

